/**
 * @description
 * Objeto parameters
 */

export class RepresentaAccLog {
    public idRepAccLog:number = null;
    public idApp:number = null;
    public numDocTer:string;
    public numDocRepr:string;
    public dataLog:Date;

    constructor() {}
  
}